<template>
  <div class="arb-basic-card">
    <v-card>
      <v-card-title v-if="enableHeader">
        <span>{{ title }}</span>
        <slot name="widget-header-checkbox"></slot>
        <v-spacer></v-spacer>
        <slot name="widget-header-action"></slot>
      </v-card-title>
      <v-divider v-if="enableHeader"></v-divider>
      <v-card-text :class="contentBg">
        <slot name="widget-content"></slot>
      </v-card-text>
      <v-card-actions>
        <slot name="widget-footer-action"></slot>
        <v-spacer></v-spacer>
        <slot name="widget-footer-enter"></slot>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'arb-basic-card',
  props: {
    title: {
      type: String
    },
    enableHeader: {
      type: Boolean,
      default: true
    },
    contentBg: {
      type: String,
      default: 'white'
    }
  },

  data () {
    return {}
  },
  computed: {}
}
</script>
